import { render, staticRenderFns } from "./DraftOpportunities.vue?vue&type=template&id=50b9e87f&scoped=true&"
import script from "./DraftOpportunities.vue?vue&type=script&lang=js&"
export * from "./DraftOpportunities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b9e87f",
  null
  
)

export default component.exports